export default __webpack_public_path__ + "static/media/plus.60059416.svg";